import thMessages from "../locales/th_TH.json";

const ThLang = {
  messages: {
    ...thMessages,
  },
  antd: null,
  locale: "th",
};
export default ThLang;
